import React from 'react';

/**
 * Lista de linhas editáveis (envolvidos, testemunhas). Cada linha é um objeto
 * cujos campos são definidos por `campos`; o componente não sabe o que é
 * envolvido ou testemunha, só monta os inputs.
 */
function ListaDinamica({ itens, onChange, campos, botaoTexto, vazio }) {
  const atualizar = (index, chave, valor) => {
    const novos = itens.map((item, i) => (i === index ? { ...item, [chave]: valor } : item));
    onChange(novos);
  };

  const remover = (index) => {
    onChange(itens.filter((_, i) => i !== index));
  };

  const adicionar = () => {
    const vazio = Object.fromEntries(campos.map((c) => [c.chave, c.tipo === 'select' ? campos.find(cc => cc.chave === c.chave).opcoes[0].value : '']));
    onChange([...itens, vazio]);
  };

  return (
    <div className="list-dinamica">
      {itens.length === 0 && vazio && <p className="help-text">{vazio}</p>}
      {itens.map((item, index) => (
        <div className="list-dinamica__item" key={index}>
          <button type="button" className="list-dinamica__remove" onClick={() => remover(index)}>
            Remover
          </button>
          {campos.map((campo) => (
            <div className="form-group" key={campo.chave}>
              <label>{campo.rotulo}</label>
              {campo.tipo === 'select' ? (
                <select
                  value={item[campo.chave] || campo.opcoes[0].value}
                  onChange={(e) => atualizar(index, campo.chave, e.target.value)}
                >
                  {campo.opcoes.map((op) => (
                    <option key={op.value} value={op.value}>{op.label}</option>
                  ))}
                </select>
              ) : (
                <input
                  type="text"
                  value={item[campo.chave] || ''}
                  placeholder={campo.placeholder}
                  onChange={(e) => atualizar(index, campo.chave, e.target.value)}
                />
              )}
            </div>
          ))}
        </div>
      ))}
      <button type="button" className="list-dinamica__add" onClick={adicionar}>
        + {botaoTexto}
      </button>
    </div>
  );
}

export default ListaDinamica;
